var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveIdle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12499 10C8.12499 11.0355 8.96446 11.875 9.99999 11.875C11.0355 11.875 11.875 11.0355 11.875 10C11.875 8.96447 11.0355 8.125 9.99999 8.125C8.96446 8.125 8.12499 8.96447 8.12499 10Z",
    fill: "#155DFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14809 15.2716C3.98883 15.8333 5.15922 15.8333 7.49999 15.8333L12.5 15.8333C14.8408 15.8333 16.0111 15.8333 16.8519 15.2716C17.2159 15.0284 17.5284 14.7159 17.7716 14.3519C18.3333 13.5112 18.3333 12.3408 18.3333 10C18.3333 7.65923 18.3333 6.48884 17.7716 5.6481C17.5284 5.28413 17.2159 4.97163 16.8519 4.72844C16.0111 4.16667 14.8408 4.16667 12.5 4.16667H7.49999C5.15922 4.16667 3.98883 4.16667 3.14809 4.72844C2.78412 4.97163 2.47162 5.28413 2.22842 5.6481C1.66666 6.48885 1.66666 7.65923 1.66666 10C1.66666 12.3408 1.66666 13.5112 2.22842 14.3519C2.47162 14.7159 2.78412 15.0284 3.14809 15.2716ZM9.99999 13.125C8.2741 13.125 6.87499 11.7259 6.87499 10C6.87499 8.27411 8.2741 6.875 9.99999 6.875C11.7259 6.875 13.125 8.27411 13.125 10C13.125 11.7259 11.7259 13.125 9.99999 13.125ZM4.58332 13.125C4.23815 13.125 3.95832 12.8452 3.95832 12.5L3.95832 7.5C3.95832 7.15482 4.23815 6.875 4.58332 6.875C4.9285 6.875 5.20832 7.15482 5.20832 7.5L5.20832 12.5C5.20832 12.8452 4.9285 13.125 4.58332 13.125ZM14.7917 12.5C14.7917 12.8452 15.0715 13.125 15.4167 13.125C15.7618 13.125 16.0417 12.8452 16.0417 12.5V7.5C16.0417 7.15482 15.7618 6.875 15.4167 6.875C15.0715 6.875 14.7917 7.15482 14.7917 7.5V12.5Z",
    fill: "#155DFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIdle);
export default __webpack_public_path__ + "static/media/Active Idle.ca8a64ebd8a1adf0f78b8b87c7b74b4e.svg";
export { ForwardRef as ReactComponent };